import { Button, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React, { useState, useEffect } from 'react'
import MainCard from 'ui-component/cards/MainCard'
import SubCard from 'ui-component/cards/SubCard'
import { IoMdArrowBack } from "react-icons/io";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import FieldsTable from './FieldsTable'
import ApprovalStepper from './Components/ApprovalStepper'
import useMediaQuery from '@mui/material/useMediaQuery';
import {  GetApprovalData } from 'API/Ds Approval/api'
import { getConfigData } from 'API/Config/api'



function ApproveForm() {
// check

    const userType = sessionStorage.getItem('UserType');
    const [configData,setConfigData]=useState(null)
    // const userId = sessionStorage.getItem('user_id');

    // const data = [
    //     {
    //         "_id": {
    //             "$oid": "65c0c63206f7372297883f3a"
    //         },
    //         "agent_name": "Koushik",
    //         "agent_id": "001",
    //         "products": [
    //             {
    //                 "product_name": "Product A",
    //                 "ds_id": "100",
    //                 "ds_permission": "approved",
    //                 "tm_id": "string",
    //                 "tm_permission": "approved",
    //                 "sh_id": "",
    //                 "sh_permission": "pending",
    //                 "status": "active"
    //             },
    //             {
    //                 "product_name": "Product B",
    //                 "ds_id": "100",
    //                 "ds_permission": "approved",
    //                 "tm_id": "string",
    //                 "tm_permission": "pending",
    //                 "sh_id": "",
    //                 "sh_permission": "pending",
    //                 "status": "active"
    //             }
    //         ]
    //     },
    //     {
    //         "_id": {
    //             "$oid": "65c0c63206f7372297883f3b"
    //         },
    //         "agent_name": "sads",
    //         "agent_id": "002",
    //         "products": [
    //             {
    //                 "product_name": "Product A",
    //                 "ds_id": "100",
    //                 "ds_permission": "approved",
    //                 "tm_id": "string",
    //                 "tm_permission": "pending",
    //                 "sh_id": "",
    //                 "sh_permission": "pending",
    //                 "status": "active"
    //             },
    //             {
    //                 "product_name": "Product C",
    //                 "ds_id": "100",
    //                 "ds_permission": "approved",
    //                 "tm_id": "string",
    //                 "tm_permission": "approved",
    //                 "sh_id": "",
    //                 "sh_permission": "approved",
    //                 "status": "active"
    //             }
    //         ]
    //     }
    // ]

    const [data, setData] = useState(null)

    const [value, setValue] = React.useState(null);
    const [Selected, setSelected] = React.useState(null);

    // const handleSelect=()=>{
    //     setSelected(value)
    // }

    const handleItemClick = (index) => {
        setValue(data[index]);
        setSelected(data[index])
    };

    console.log('value', value);
    // function createData(name) {
    //     return { name };
    // }

    //   const rows = [
    //     createData('Frozen yoghurt'),

    //   ];

    const [rows, setRows] = React.useState([])

    // React.useEffect(() => {
    //     if (Selected) {
    //         Selected.fields.forEach(element => {
    //             setRows(prevRows => [...prevRows, createData(element.title)]);
    //         });
    //     }

    // }, [Selected])


    const handleClose = () => {
        setSelected(null)
        setRows([])
    }

    useEffect(() => {
        GetApprovalData(setData)
        getConfigData(setConfigData)
    }, [])

    const orientation = useMediaQuery('(min-width:600px)') ? 'row' : 'column';
    const height = useMediaQuery('(min-width:600px)') ? '70vh' : '20vh'

    console.log(data);
    console.log(userType);

    return (
        Selected ?
            <div>
                <Stack direction='row' alignItems='center'>
                    <Button sx={{ width: '20px' }} onClick={handleClose}><IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} /></Button>
                    <Typography variant='subtitle1' color='grey'>{Selected.title}</Typography>
                </Stack>
                <TableContainer component={Paper}>
                    <FieldsTable userType={userType} configData={configData}  rows={rows} selectedItem={Selected} />

                </TableContainer>

            </div>
            :
            <div
                style={{ width: '100%', display: 'flex', gap: '30px', flexDirection: orientation, }}>
                <div style={{ height: height, overflowY: 'scroll', width: '55%', scrollbarWidth: 'none' }}>
                    <Stack spacing={2} sx={{ width: '100%', height: '45rem' }}>
                        {data && data.map((item, index) => {
                            console.log(item);
                            return(

                                    (userType === 'ops'||userType==='rm'||userType==='sh')
                                   ?
                                   <SubCard title={`Onboarding for ${item.user_name}`} key={index} sx={{ cursor: 'pointer' }} onClick={() => handleItemClick(index)}>
                                   <Stack direction='column' >
                                       <div></div>
                                       <Stack direction='column'>

                                       </Stack>
                                   </Stack>
                               </SubCard>
                                    :
                                    null
                            )


                        }
                        )}

                    </Stack>
                </div>
                <div>
                    {userType && userType.type === 'agent' ?
                        <div style={{ height: '75vh', overflowY: 'scroll', width: '100%', scrollbarWidth: 'none' }}>
                            <Stack sx={{ width: '100%', display: value ? 'flex' : 'none' }}>
                                <MainCard sx={{ width: '100%', backgroundColor: 'whitesmoke' }}>
                                    <SubCard title={value ? value.product_name : ''}>
                                        <ApprovalStepper data={value} />
                                    </SubCard>
                                </MainCard>
                            </Stack>
                        </div>
                        :
                        null
                    }

                </div>
            </div>
    )
}

export default ApproveForm
